import styled, { keyframes } from 'styled-components';
import { spacings } from '../../styles/theme';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: ${spacings.lg};
  animation: ${fadeIn} 0.2s ease-out;
`;

export const ModalContent = styled.div`
  animation: ${slideIn} 0.3s ease-out;
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
`;
